import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

/**
 * Transactions module navigation — spec-48 W1
 * AR-first per BRD §11.3.
 */
export const transactionsNavigation: ModuleNavigation = [
  {
    title: 'Overview',
    items: [
      { path: '/transactions', label: 'Transactions Home' },
    ],
  },
  {
    title: 'Matters',
    items: [
      { path: '/transactions/matters', label: 'All Matters' },
      { path: '/transactions/kanban/all', label: 'Kanban Pipeline' },
      { path: '/tasks', label: 'My Tasks' },
    ],
  },
  {
    title: 'Operations',
    items: [
      { path: '/transactions/grid', label: 'Transactions Grid' },
    ],
  },
];
